import { render, staticRenderFns } from "./ProjectApproveDialog.vue?vue&type=template&id=4f4a921f&scoped=true&"
import script from "./ProjectApproveDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectApproveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectApproveDialog.vue?vue&type=style&index=0&id=4f4a921f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a921f",
  null
  
)

export default component.exports